import { DetailedResourceNodeFieldsFragment, TagsFieldsFragment } from '@api/gql/graphql';
import { Stack } from '@mui/material';
import { ResourceDetailsTable } from '@Inventory/components/ResourceDetailsTable';
import { TagsTable } from '@Inventory/components/TagsTable';

export function ResourceDetailsTab({
  resource,
  tagsData,
}: {
  resource: DetailedResourceNodeFieldsFragment;
  tagsData: TagsFieldsFragment[];
}) {
  return (
    <Stack direction="column" spacing={2}>
      <ResourceDetailsTable resource={resource} />
      <TagsTable tagsData={tagsData} />
    </Stack>
  );
}
